// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"177":"home","839":"donationCreate"}[chunkId] + "." + {"177":"7d6efcc7","839":"85629066"}[chunkId] + ".css";
};